import React, { useEffect } from "react";
import { Route, Routes, BrowserRouter as Router, Outlet, Navigate, useSearchParams } from "react-router-dom";
import Page404 from "../pages/404/404.page";
import { useAppContext } from "../context/app.context";
import RegisterStep1Page from "../pages/register/steps/registerStep1.page";
import RegisterStep2Page from "../pages/register/steps/registerStep2.page";
import RegisterSuccessPage from "../pages/register/steps/registerSuccess.page";
import RegisterStep3Page from "../pages/register/steps/registerStep3.page";
import RegisterStep4Page from "../pages/register/steps/registerStep4.page";

export default function AppRoutes() {   
  return (
    <Router>
      <Routes>
        <Route path="/" element={<RegisterStep1Page />} />
        <Route path="/register/step2" element={<RegisterStep2Page />} />
        <Route path="/register/step3" element={<RegisterStep3Page />} />
        <Route path="/register/step4" element={<RegisterStep4Page />} />
        <Route path="/register/success" element={<RegisterSuccessPage />} />
        <Route path="*" element={<Navigate replace to="/" />} />
      </Routes>
    </Router>
  );
}

export function ActiveStatusRoute() {
  const { appInfos } = useAppContext();
  return appInfos.user.status == "Active" ? <Outlet /> : <Navigate replace={true} to={"/structure/profil"} />;
}

export function ConnectedRoute({ userRole }: any) {
  const { appInfos } = useAppContext();
  return appInfos.token && appInfos?.user?.role == userRole ? (
    <Outlet />
  ) : appInfos.token ? (
    <Page404 />
  ) : (
    <Navigate replace={true} to="/login" />
  );
}

export function DisconnectedRoute() {
  const { appInfos } = useAppContext();
  return appInfos.token && appInfos.user.status == "Active" ? (
    <Navigate replace to={appInfos?.user?.role == "Structure" ? "/structure" : "/prestataire"} />
  ) : (
    <Outlet />
  );
}
